import React, { useState, useRef } from "react"
import { PhotoSwipe } from "react-photoswipe"

import * as galleryStyles from './gallery.module.scss'
import 'react-photoswipe/lib/photoswipe.css'
import './pswpLight.scss'



const allFileToPswp = (allFile) => {
    return allFile.nodes.map(
        (file) => ({
            src: file.childImageSharp.original,
            w: file.childImageSharp.original.width,
            h: file.childImageSharp.original.height,
            pid: file.name,
            thumbnail: {
                src: file.childImageSharp.thumbnail.src,
                w: file.childImageSharp.thumbnail.width,
                h: file.childImageSharp.thumbnail.height,
            },
            name: file.name
        })
    )
}



const Gallery = ({items}) => {

    const [state, setState] = useState({open: false, index: 0})

    const handleImgClick = (index) => {
        setState({
            open: true,
            index: index
        })
    }

    const handleClose = () => {
        setState(s => ({...s, open: false}))
    }

    const thumbnailsRef = useRef([])

    const getThumbBoundsFn = (index) => {
        let scrollOffset = 
            window
                ? window.pageYOffset || document.documentElement.scrollTop
                : 0

        let rect = thumbnailsRef.current[index].getBoundingClientRect()

        return ({
            x: rect.left,
            y: rect.top + scrollOffset,
            w: rect.width
        })
    }

    const pswpNodes = allFileToPswp(items)

    return <>
        <div className={galleryStyles.galleryWrapper}>
            {
                pswpNodes.map((item, index) => 
                    <div role="button"
                        onClick={() => handleImgClick(index)}
                        onKeyPress={() => handleImgClick(index)}
                        tabIndex={0}
                        key={item.name}
                    >
                        <img 
                            src={item.thumbnail.src} 
                            alt={item.name}
                            width={item.thumbnail.w}
                            height={item.thumbnail.h}
                            ref={ (node) => thumbnailsRef.current[index] = node }
                        />
                    </div>
                )
            }
        </div>
        <PhotoSwipe 
            items={pswpNodes.map(i => ({...i, src: i.src.src}))} 
            isOpen={state.open}
            options={{index: state.index, getThumbBoundsFn}}
            onClose={handleClose}
            className={`light0`}
        />
    </>
}


export default Gallery